import React from "react";
import Modal from '../../component/Inc/Modal';
function PopRecommend(props) {
  const { open, close } = props;
  return (
    <Modal open={open} close={close} type="com_input pop_recommend">
      <h2 className='pop_tit'>우수 교사 추천</h2>
      <div className="content_container scroll">
        <section className='search search_top'>
          <input type="search" placeholder='교사명 검색' className="input s type_search" />
          <button className="com_btn gray ws s icon_search"></button>
        </section>
        <section className='result_search'>
          <div className='item'>
            <button className='btn_delete'>삭제</button>
            <span className='text'>홍교사123</span>
          </div>
        </section>
        <textarea className="textarea" placeholder="추천 사유 입력"></textarea>
      </div>
      <div className="btn_container">
        <button className="com_btn orange full xs">등록</button>
      </div>
    </Modal>
  );
}

export default PopRecommend;